<template>
  <div class="about fxd .f b-c b-cl a-c -o-h c-0-b">
    <div class="a-c">
      <SwingTitle over="true" style="font-size: calc(120px + 5vw) !important;" class="-z-n -i-h">404😅</SwingTitle>
      <p class="o-5">Page not found!</p>
      <router-link to="/" class="unt btn-n"><i class="material-icons -i-x">arrow_back</i>Go Home</router-link>
    </div>
  </div>
</template>
<script>
import SwingTitle from '../components/SwingTitle'

export default {
  components: {
    SwingTitle
  }
}
</script>
